module.exports = "<script type=\"text/html\" id=\"propertyeditor-html\">\n  <!-- ko template: { name: 'propertyeditor-modal', data: $data } --><!-- /ko -->\n</script>\n\n<script type=\"text/html\" id=\"propertyeditorcontent-html\">\n  <textarea class=\"form-control\" data-bind=\"textInput:koValue, disable: readOnly\" style=\"width:100%;height:auto\" rows=\"10\" autofocus=\"autofocus\"></textarea>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-html.html
// module id = 119
// module chunks = 0